import Layout from '@/container/Full'
const ProfileMenu = () => import(/* webpackChunkName: "profile" */ '@/views/profile/Profile')
const ProfileInfo = () => import(/* webpackChunkName: "profile" */ '@/views/profile/ProfileInfo')
// const ProfilePayment = () => import(/* webpackChunkName: "profile" */ './../components/Profile/ProfilePayment')
const ProfileSecurity = () => import(/* webpackChunkName: "profile" */ '@/views/profile/ProfileSecurity')
const ProfilePrivacy = () => import(/* webpackChunkName: "profile" */ '@/views/profile/ProfilePrivacy')
const ProfileGGSeal = () => import(/* webpackChunkName: "profile" */ '@/views/profile/ProfileGGSeal')
const ProfileAccess = () => import(/* webpackChunkName: "profile" */ '@/views/profile/ProfileAccess')
const ProfileAccessManage = () => import(/* webpackChunkName: "profile" */ '@/views/profile/ProfileAccessManage')

const routes = [
  {
    path: '/profile',
    component: Layout,
    meta: {
      access_type: 'authorized',
      pageTitle: 'Profile',
    },
    children: [
      {
        path: '',
        component: ProfileMenu,
        meta: {
          title: 'message.userProfile',
          pageTitle: 'My Profile',
          breadcrumb: 'Profile',
          access_type: 'authorized',
        },
        children: [
          {
            path: '',
            name: 'profile_info',
            component: ProfileInfo,
            meta: {
              pageTitle: 'My Profile',
              access_type: 'authorized',
            }
          },
          {
            path: 'security',
            name: 'profile_security',
            component: ProfileSecurity,
            meta: {
              pageTitle: 'Account Security',
              access_type: 'authorized',
            }
          },
          {
            path: 'privacy',
            name: 'profile_privacy',
            component: ProfilePrivacy,
            meta: {
              pageTitle: 'Privacy',
              access_type: 'authorized',
            }
          },
          {
            path: 'ggseal',
            name: 'profile_ggseal',
            component: ProfileGGSeal,
            meta: {
              pageTitle: 'GreenGeeks Seal',
              access_type: 'authorized',
            }
          },
          {
            path: 'access',
            name: 'profile_access',
            component: ProfileAccess,
            meta: {
              pageTitle: 'Account Access',
              access_type: 'authorized',
            }
          },
          {
            path: 'access/:id',
            name: 'profile_access_manage',
            component: ProfileAccessManage,
            meta: {
              pageTitle: 'Account Access',
              access_type: 'authorized'
            }
          },
          // {
          //   path: 'payment',
          //   name: 'profile_payment',
          //   component: ProfilePayment
          // },
        ]
      }
    ]
  },
]

export default routes
